import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import Spinner from 'components/Spinner/Spinner';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import {ExecutionStatus, NormalizationType, RuntimeMode} from 'constants/dataEnum';
import {useArrowDownPress, useArrowUpPress, useClickOutside} from 'lib/customHooks';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';

import './NormalizationTasksContainer.scss';
import NormalizationPipettingProfileContainer from './NormalizationPipettingProfileContainer';
import getTaskTitle from './NormalizationTasksHelper';

function NormalizationSetup({
  number,
  runtimeMode,
  executionStatus,
  targetConcentration,
  currentVolume,
  onEdit,
  showEditButton,
  onSelectTask,
  isHighlighted,
  onArrowUpPress,
  onArrowDownPress,
  readOnly,
  runtimeStatus,
  normalizationType,
  card,
}) {
  const taskRef = useRef();
  const onClickOutside = () => {
    if (isHighlighted) {
      onSelectTask();
    }
  };

  useClickOutside(taskRef, onClickOutside);
  useArrowUpPress(taskRef, onArrowUpPress);
  useArrowDownPress(taskRef, onArrowDownPress);

  const currentVolumeDescription =
    normalizationType === NormalizationType.FIXED_DILUENT_VOLUME
      ? `Current Diluent Volume <${currentVolume}μL>`
      : `Current Sample Volume <${currentVolume}μL>`;

  return (
    <TaskWrapper disableDrag isSelected={isHighlighted} ref={taskRef} onClick={onSelectTask}>
      <div>
        <TaskNumber number={number} isHighlighted={isHighlighted} />
      </div>
      <div className="task-description">
        <span className="bold">{getTaskTitle(number)}</span>
        &nbsp;
        <br />
        <span className="green">{`Target Concentration <${targetConcentration}μL>`}</span>
        <br />
        <span className="green">{currentVolumeDescription}</span>
        <br />
      </div>
      {!runtimeMode && showEditButton && <TaskAction onEdit={() => onEdit(number)} />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && (
        <img className="executed" src="./svg/protocol-editor/execution-done.svg" alt="Executed" />
      )}
      {((number === 3 && !runtimeMode) || (number === 3 && runtimeMode && runtimeStatus === RuntimeMode.PAUSED)) &&
        !readOnly && (
          <div className="task-pipetting-param">
            <NormalizationPipettingProfileContainer runtimeMode={runtimeMode} selectedCard={card} />
          </div>
        )}
    </TaskWrapper>
  );
}

NormalizationSetup.propTypes = {
  runtimeMode: PropTypes.bool,
  executionStatus: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  number: PropTypes.number.isRequired,
  targetConcentration: PropTypes.number.isRequired,
  currentVolume: PropTypes.number.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  onArrowUpPress: PropTypes.func.isRequired,
  onArrowDownPress: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  runtimeStatus: PropTypes.string.isRequired,
  normalizationType: PropTypes.string.isRequired,
  card: PropTypes.object.isRequired,
};

NormalizationSetup.defaultProps = {
  runtimeMode: false,
  executionStatus: '',
  readOnly: false,
};

export default NormalizationSetup;
